import { render, staticRenderFns } from "./bindPayableOrder.vue?vue&type=template&id=190e1d37&scoped=true"
import script from "./bindPayableOrder.vue?vue&type=script&lang=js"
export * from "./bindPayableOrder.vue?vue&type=script&lang=js"
import style0 from "./bindPayableOrder.vue?vue&type=style&index=0&id=190e1d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e1d37",
  null
  
)

export default component.exports